import { Close } from '@mui/icons-material';
import { IconButton, styled } from '@mui/material';

export default function CloseDialogButton({ onClose }: { onClose: () => void }) {
    return (
        <StyledIconButton onClick={ onClose }>
            <Close fontSize="small" />
        </StyledIconButton>
    );
}

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    width: theme.spacing(10),
    height: theme.spacing(10),
    marginRight: theme.spacing(2)
}));
